import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  transition: opacity 0.25s linear;\n  opacity: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flexflow: column;\n  alignitems: center;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  &:focus-within {\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  cursor: pointer;\n  padding-top: 48.66%;\n\n  &:hover ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  margin-top: 16px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  margin-top: 16px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  text-align: center;\n  letter-spacing: 0.003px;\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  text-decoration: underline;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import { AspectRatioBox, Box, Button, prefixUrl } from "@miro-site/core";
import NextImage from "next/image";
import { initiatePreproductBoardAction, initiatePreproductBoardEvent, usePreproductPreviewContext, Board } from "@miro-site/preproduct-preview";
var previewVisibleStyles = css(_templateObject());
var ButtonContainer = styled(Box).withConfig({
    componentId: "sc-78f01bf2-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.primaryWhite;
});
var PreviewContainer = styled(Box).attrs({
    $styles: {
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        transition: "opacity 0.25s linear",
        opacity: 0,
        background: "rgba(0, 0, 0, 0.8)"
    }
}).withConfig({
    componentId: "sc-78f01bf2-1"
})(_templateObject2(), previewVisibleStyles);
var EmbedContainer = styled(AspectRatioBox).withConfig({
    componentId: "sc-78f01bf2-2"
})(_templateObject3(), PreviewContainer, previewVisibleStyles);
var TermsTextContainer = styled.div.withConfig({
    componentId: "sc-78f01bf2-3"
})(_templateObject4());
var TermsText = styled.span.withConfig({
    componentId: "sc-78f01bf2-4"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.primaryWhite;
});
var TermsLink = styled(TermsText).withConfig({
    componentId: "sc-78f01bf2-5"
})(_templateObject6());
var BoardContainer = styled.div.withConfig({
    componentId: "sc-78f01bf2-6"
})(_templateObject7());
var EditableTemplatePreview = function() {
    var ref = useState(false), isEmbedVisible = ref[0], setEmbedVisible = ref[1];
    var ref1 = useState({}), previewStyles = ref1[0], setPreviewStyles = ref1[1];
    var ref2 = usePreproductPreviewContext(), dispatch = ref2.dispatch, iframeState = ref2.iframeState, boardContainerState = ref2.boardContainerState;
    var _editableTemplates = boardContainerState.editableTemplates, isEditableTemplateBoardActive = _editableTemplates.isEditableTemplateBoardActive, image = _editableTemplates.editableTemplatePreview;
    useEffect(function() {
        setPreviewStyles({
            display: isEmbedVisible || isEditableTemplateBoardActive ? "none" : "block"
        });
    }, [
        isEmbedVisible,
        isEditableTemplateBoardActive
    ]);
    var handleOpenTerms = function(e) {
        e.stopPropagation();
        window.open("https://miro.com/legal/terms-of-service/", "_blank");
    };
    var handleOpenCookieSettings = function(e) {
        e.stopPropagation();
        OneTrust.ToggleInfoDisplay();
    };
    var handleEmbedVisible = function() {
        setEmbedVisible(true);
        initiatePreproductBoardAction(dispatch);
    };
    var handleBoardPreload = function() {
        if (iframeState.isIframeReady) {
            initiatePreproductBoardEvent(iframeState.iframeRef, false);
        }
    };
    var handleBoardInitiate = function() {
        if (iframeState.isIframeReady) {
            initiatePreproductBoardEvent(iframeState.iframeRef, true);
            handleEmbedVisible();
            OneTrust.AllowAll();
        }
    };
    return /*#__PURE__*/ _jsxs(EmbedContainer, {
        "data-testid": "board-embed-preview-container",
        $width: 720,
        $height: 480,
        onClick: handleBoardInitiate,
        onMouseOver: handleBoardPreload,
        children: [
            /*#__PURE__*/ _jsx(BoardContainer, {
                children: /*#__PURE__*/ _jsx(Board, {})
            }),
            /*#__PURE__*/ _jsxs("div", {
                style: previewStyles,
                "data-testid": "board-embed-preview-image-container",
                children: [
                    /*#__PURE__*/ _jsx(NextImage, {
                        src: prefixUrl(image.original.webp || image.original.jpg),
                        unoptimized: true,
                        alt: image.name,
                        priority: true,
                        layout: "fill"
                    }),
                    /*#__PURE__*/ _jsx(PreviewContainer, {
                        children: /*#__PURE__*/ _jsxs(ButtonContainer, {
                            $styles: {
                                display: "flex",
                                flexFlow: "column",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    $buttonType: "primary",
                                    $size: "medium",
                                    onClick: handleBoardInitiate,
                                    children: /*#__PURE__*/ _jsx(Box, {
                                        $styles: {
                                            display: "flex",
                                            flexFlow: "row nowrap",
                                            alignItems: "center"
                                        },
                                        children: iframeState.isIframeReady ? "Try it out live" : "Loading..."
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(TermsTextContainer, {
                                    children: [
                                        /*#__PURE__*/ _jsx(TermsText, {
                                            children: "By trying it out you accept our "
                                        }),
                                        /*#__PURE__*/ _jsx(TermsLink, {
                                            onClick: handleOpenTerms,
                                            children: "terms of service"
                                        }),
                                        /*#__PURE__*/ _jsx(TermsText, {
                                            children: " and "
                                        }),
                                        /*#__PURE__*/ _jsx(TermsLink, {
                                            onClick: handleOpenCookieSettings,
                                            children: "cookie settings"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
export default EditableTemplatePreview;
